// Angular
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { KeyValue } from '@angular/common';
// 3rd-party
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

@Component({
    selector: 'app-field-multiple-input',
    templateUrl: './field-multiple-input.component.html',
    styleUrls: ['./field-multiple-input.component.scss'],
    standalone: false
})
export class FieldMultipleInputComponent<T> {
    @Input() disabled: boolean = false;
    @Input() error: string = '';
    @Input() label?: string = '';
    @Input() items: KeyValue<number, string>[] = [];
    @Input() options: KeyValue<number, string>[] = [];

    @Output() deleteClicked: EventEmitter<number> = new EventEmitter<number>();
    @Output() addItem: EventEmitter<KeyValue<number, string>> = new EventEmitter<KeyValue<number, string>>();

    @ViewChild(NgbTypeahead) ngbTypeahead: NgbTypeahead;
    @ViewChild('instance', { static: true }) instance: NgbTypeahead;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();

    search = (text$: Observable<string>) => {
        const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
        const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
        const inputFocus$ = this.focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
            map((term) =>
                this.options
                    .filter((item) => {
                        if (this.items.findIndex((i) => i.key === item.key) > -1) {
                            return false;
                        }
                        let searchValue = '';
                        if (item.value) {
                            searchValue += `${item.value}`;
                        }
                        return searchValue?.toLowerCase().includes(`${term?.toLowerCase()}`);
                    })
                    .slice(0, 100)
            )
        );
    };

    formatter = (item: KeyValue<number, string>) => {
        if (item) {
            return item.value;
        }
    };

    onDeleteClicked(item: number) {
        if (!this.disabled) {
            this.deleteClicked.emit(item);
        }
    }

    get isOpen(): boolean {
        if (this.ngbTypeahead) {
            return this.ngbTypeahead.isPopupOpen();
        } else return false;
    }

    onBlur(input: HTMLInputElement): void {
        input.value = '';
    }

    onSelect(event: NgbTypeaheadSelectItemEvent<KeyValue<number, string>>, input: HTMLInputElement) {
        event.preventDefault();
        input.blur();
        this.addItem.emit(event.item);
    }
}
